import * as React from 'react'
import { getStatusOptions } from '@paintscout/util/builder'
import type {
  DropdownSelectOption,
  MultiSelectProps,
  DropdownSelectProps,
  SingleSelectProps
} from '@paintscout/ui-business'
import { DropdownSelect } from '@paintscout/ui-business'

const anyOption = { value: null as string, label: 'Any Status' }

interface QuoteStatusSelectionProps extends Omit<DropdownSelectProps, 'value'> {
  value?: string | string[]
  invoice?: boolean
  allowInvoiced?: boolean
  showAny?: boolean
}

export default function QuoteStatusSelection({
  invoice,
  allowInvoiced,
  value = [],
  showAny,
  ...props
}: QuoteStatusSelectionProps) {
  const options = React.useMemo(() => {
    const statusOptions = getStatusOptions({ isInvoice: invoice, allowInvoiced })
    if (showAny) {
      statusOptions.unshift(anyOption)
    }
    return statusOptions
  }, [invoice, allowInvoiced])

  const selectedValues: DropdownSelectOption[] = options.filter((option) =>
    (Array.isArray(value) ? value : [value]).includes(option.value)
  )

  const singleSelectProps = { ...props, value: selectedValues[0], variant: 'single' } as SingleSelectProps
  const multiSelectProps = { ...props, value: selectedValues, variant: 'multi' } as MultiSelectProps

  const selectProps = props.variant === 'multi' ? multiSelectProps : singleSelectProps

  return <DropdownSelect {...selectProps} options={options} />
}
